import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCookie, setCookie, clearCookie } from "../cookie_helper/cookie";

const getToken = () => localStorage.getItem("token") || getCookie("token");
const getRefreshToken = () =>
  localStorage.getItem("refreshToken") || getCookie("refreshToken");

const setTokens = (token, refreshToken) => {
  localStorage.setItem("token", token);
  setCookie("token", token);
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
    setCookie("refreshToken", refreshToken);
  }
};

const forceLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("role");
  clearCookie("token");
  clearCookie("refreshToken");
  clearCookie("userId");
  window.location.href = "/";
};

const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_SERVER_URL,
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

// All RTK Query APIs share this module, so every request that hits a 401 at
// the same moment awaits one in-flight refresh call instead of each firing
// its own (which would race to rotate the refresh token on the backend).
let refreshPromise = null;

const performRefresh = async (api, extraOptions) => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return false;

  const refreshResult = await rawBaseQuery(
    { url: "admin/refresh-token", method: "POST", body: { refreshToken } },
    api,
    extraOptions
  );

  if (refreshResult.data?.token) {
    setTokens(refreshResult.data.token, refreshResult.data.refreshToken);
    return true;
  }

  return false;
};

export const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    if (!refreshPromise) {
      refreshPromise = performRefresh(api, extraOptions).finally(() => {
        refreshPromise = null;
      });
    }

    const refreshed = await refreshPromise;

    if (refreshed) {
      result = await rawBaseQuery(args, api, extraOptions);
    }

    if (!refreshed || (result.error && result.error.status === 401)) {
      forceLogout();
    }
  }

  return result;
};
